require('./index.css')

class BrandNotificationBar {}

export default BrandNotificationBar



// WEBPACK FOOTER //
// ./src/components/notification-bar/index.js